import { agreementsNames } from '@repo/shared/types';
import { PRAGMA_TERMS_LINK, PRZELEWY24_TERMS_LINK } from '@repo/shared/constants';

import { MODAL_STATE } from '@/components/modal/modal.store';

import { LoanTerms } from './agreements-modal-contents/loan-terms';
import { PragmaTerms } from './agreements-modal-contents/pragma-terms';
import { BikbigTerms } from './agreements-modal-contents/bikbig-terms';
import { PayproDataProcessingTerms } from './agreements-modal-contents/paypro-data-processing-terms';
import { PragmagoDataProcessingTerms } from './agreements-modal-contents/pragmago-data-processing-terms';
import { ProfessionalContract } from './agreements-modal-contents/professional-contract';
import { RepresentativeTerms } from './agreements-modal-contents/representative-terms';

export const pragmaAgreements = [
  {
    title: 'loanFormPage.agreements.form.fields.representative.title',
    name: agreementsNames.enum['representative'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
    modalBodyChildren: <RepresentativeTerms />,
  },
  {
    title: 'loanFormPage.agreements.form.fields.loanTerms.title',
    link: PRZELEWY24_TERMS_LINK,
    modalBodyChildren: <LoanTerms />,
    name: agreementsNames.enum['loanTerms'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
  {
    title: 'loanFormPage.agreements.form.fields.pragmaTerms.title',
    link: PRAGMA_TERMS_LINK,
    modalBodyChildren: <PragmaTerms />,
    name: agreementsNames.enum['pragmaTerms'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
  {
    title: 'loanFormPage.agreements.form.fields.bikbig.title',
    modalBodyChildren: <BikbigTerms />,
    name: agreementsNames.enum['bikbig'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
  {
    title: 'loanFormPage.agreements.form.fields.professionalContract.title',
    modalBodyChildren: <ProfessionalContract />,
    name: agreementsNames.enum['professionalContract'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
  {
    title: 'loanFormPage.agreements.form.fields.marketing.content',
    name: agreementsNames.enum['marketing'],
  },
  {
    title: 'loanFormPage.agreements.form.fields.payproDataProcessing.title',
    modalBodyChildren: <PayproDataProcessingTerms />,
    name: agreementsNames.enum['payProDataProcessing'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
  {
    title: 'loanFormPage.agreements.form.fields.pragmaGoDataProcessing.title',
    modalBodyChildren: <PragmagoDataProcessingTerms />,
    name: agreementsNames.enum['pragmaGoDataProcessing'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
];
